<template>
  <label class="flex align-center form-row checkbox-wrapper pointer">
    <input type="checkbox" class="pointer" :value="false" v-model="modeled">
    <span class="label-text">{{labelText}}</span>
  </label>
</template>

<script>
import {ref, watch} from "vue";

export default {
  name: "CheckboxWrapper",
  props:{
    modelValue:Boolean,
    labelText:String,
  },
  setup(props, {emit}){
    const modeled = ref(props.modelValue)
    watch(() => props.modelValue, (val) => {
      modeled.value = val
    })
    watch(() => modeled.value, (val) => {
      emit("update:modelValue", val)
    })
    return {modeled}
  }
}
</script>

<style scoped>
.form-row.checkbox-wrapper {
  height: 30px;
  width: 48%;
}
.form-row.checkbox-wrapper > input {
  width: 20px;
  height: 20px;
}
.form-row.checkbox-wrapper > span.label-text {
  position: relative;
  padding-left: 4px;
  font-size: .9rem;
  width: 100%;
  margin-bottom: 0;
  margin-left: 5px;
}
</style>
